"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JakteEvents = void 0;

require("regenerator-runtime/runtime");

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _get = _interopRequireDefault(require("lodash/get"));

var _ids = require("./ids");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var JakteEvents = {
  INIT: 'jakte:init',
  UPDATE: 'jakte:update'
};
exports.JakteEvents = JakteEvents;

var Jakte =
/*#__PURE__*/
function () {
  function Jakte() {
    var _this$listeners;

    _classCallCheck(this, Jakte);

    this.initialized = false;
    this.data = {
      deviceId: null,
      sessionId: null,
      collected: {},
      user: {}
    };
    this.plugins = {};
    this.listeners = (_this$listeners = {}, _defineProperty(_this$listeners, JakteEvents.INIT, []), _defineProperty(_this$listeners, JakteEvents.UPDATE, []), _this$listeners);
    this.prevConfig = {};
  }

  _createClass(Jakte, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(config) {
        var _i, _Object$keys, pluginKey, pluginConfig, plugin, _i2, _Object$keys2, _pluginKey, _i3, _Object$keys3, _pluginKey2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (config == null) {
                  config = this.prevConfig;
                } else {
                  this.prevConfig = config;
                } // Instantiate plugins


                for (_i = 0, _Object$keys = Object.keys(this.plugins); _i < _Object$keys.length; _i++) {
                  pluginKey = _Object$keys[_i];
                  pluginConfig = (0, _get.default)(config, "plugins.".concat(pluginKey), {});
                  plugin = new this.plugins[pluginKey](this, pluginKey, pluginConfig);
                  this.plugins[pluginKey] = plugin;
                } // Run willInit


                _i2 = 0, _Object$keys2 = Object.keys(this.plugins);

              case 3:
                if (!(_i2 < _Object$keys2.length)) {
                  _context.next = 10;
                  break;
                }

                _pluginKey = _Object$keys2[_i2];
                _context.next = 7;
                return this.plugins[_pluginKey].willInit();

              case 7:
                _i2++;
                _context.next = 3;
                break;

              case 10:
                _i3 = 0, _Object$keys3 = Object.keys(this.plugins);

              case 11:
                if (!(_i3 < _Object$keys3.length)) {
                  _context.next = 18;
                  break;
                }

                _pluginKey2 = _Object$keys3[_i3];
                _context.next = 15;
                return this.plugins[_pluginKey2].init();

              case 15:
                _i3++;
                _context.next = 11;
                break;

              case 18:
                _context.next = 20;
                return (0, _ids.getDeviceId)();

              case 20:
                this.data.deviceId = _context.sent;
                this.data.sessionId = (0, _ids.getSessionId)();
                this.data.source = config.source;
                this.data.projectId = config.id;

                this._triggerListeners(JakteEvents.INIT);

                this.initialized = true;

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "use",
    value: function use(plugins) {
      this.initialized = false;
      var pluginsWithKey = plugins.reduce(function (memo, plugin) {
        return _objectSpread({}, memo, _defineProperty({}, plugin.key, plugin));
      }, {});
      this.plugins = _objectSpread({}, this.plugins, {}, pluginsWithKey);
    }
  }, {
    key: "setUser",
    value: function setUser(email, extra) {
      this.data.user = _objectSpread({}, this.data.user, {}, extra, {
        email: email
      });

      this._triggerListeners(JakteEvents.UPDATE);
    }
  }, {
    key: "dumpCollected",
    value: function dumpCollected(pluginKey) {
      if (pluginKey != null) {
        return this.data.collected[pluginKey] || {};
      }

      return this.data.collected;
    }
  }, {
    key: "dumpAll",
    value: function dumpAll() {
      return this.data;
    }
  }, {
    key: "setPluginData",
    value: function setPluginData(pluginKey, data) {
      if (pluginKey == null) {
        throw new Error('Missing key when setting data');
      } else if (!Object.keys(this.plugins).some(function (key) {
        return key === pluginKey;
      })) {
        throw new Error("Unknown plugin key \"".concat(pluginKey, "\" used when setting data"));
      } else {
        this.data.collected[pluginKey] = data;
      }

      this._triggerListeners(JakteEvents.UPDATE);
    }
  }, {
    key: "unsafeSetCollectedData",
    value: function unsafeSetCollectedData(data) {
      // Will overwrite everything inside data
      this.data.collected = typeof data === 'function' ? data((0, _cloneDeep.default)(this.data.collected)) : data;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventKey, listener) {
      if (eventKey == null) {
        throw new Error('Missing eventKey when adding listener');
      }

      this.listeners[eventKey].push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventKey, listener) {
      if (eventKey == null) {
        throw new Error('Missing eventKey when remove listener');
      }

      this.listeners[eventKey] = this.listeners[eventKey].filter(function (l) {
        return l === listener;
      });
    }
  }, {
    key: "_triggerListeners",
    value: function _triggerListeners(eventKey) {
      var listeners = this.listeners[eventKey];
      listeners.forEach(function (listener) {
        return listener();
      });
    }
  }]);

  return Jakte;
}();

var _default = Jakte;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-core/lib/Jakte.js
// module id = 397
// module chunks = 0